import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
// import ErrorMessage from '@/components/common/ErrorMessage';
import FormButtons from '@/components/common/Form/FormButtons';
import CardLayout from '@/components/Layout/CardLayout';
import FieldLayout from '@/components/Layout/FieldLayout';
import Layout from '@/components/Layout/Layout';
import BackButton from '@/components/ui/BackButton';
// import Label from '@/components/ui/Label';
import PrimaryInput from '@/components/ui/PrimaryInput';
import { IDeleteResponse } from '@/interfaces/common.model';
import { IShift } from '@/interfaces/Shits.model';
import { showToastNotification } from '@/utility/helper';
import { errorTypes } from '@/utility/validation';
import { useEffect, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
const AddShiftAndTime: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const {
    handleSubmit,
    register,
    getValues,
    reset,
    formState: { errors },
  } = useForm<IShift>();
  const parseTime = (time: string) => {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  };
  const isTimeInRange = (time: string, startTime: string, endTime: string) => {
    const parsedTime = parseTime(time);
    const parsedStart = parseTime(startTime);
    const parsedEnd = parseTime(endTime);
    // Case 1: Time range does not span midnight
    if (parsedStart < parsedEnd) {
      return parsedTime >= parsedStart && parsedTime <= parsedEnd;
    }
    // Case 2: Time range spans midnight
    return parsedTime >= parsedStart || parsedTime <= parsedEnd;
  };
  const createTimeValidation = (
    label: string,
    getValues: (field: string) => string,
  ) => ({
    required: `${label} is required`,
    validate: (value: string) => {
      const startTime = getValues('startTime');
      const endTime = getValues('endTime');
      return (
        isTimeInRange(value, startTime, endTime) ||
        `${label} must be between Start Time and End Time`
      );
    },
  });
  const validations = {
    checkInBufferTime: createTimeValidation('Check-In Buffer Time', getValues),
    checkOutBufferTime: createTimeValidation(
      'Check-Out Buffer Time',
      getValues,
    ),
  };
  const onSubmit: SubmitHandler<IShift> = async (data) => {
    setIsLoading(true);
    try {
      const response: IDeleteResponse = await callApi(
        location?.state?.data
          ? API_URL +
              API_ENDPOINT.updateShift +
              `?shiftId=${location?.state?.data?.id}`
          : API_URL + API_ENDPOINT.addShift,
        { method: 'POST', data: data },
      );

      if (response?.status) {
        showToastNotification('success', response?.message);
        navigate(-1);
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (location?.state?.data) {
      const data = location?.state?.data;
      reset({
        type: data?.type,
        shiftName: data?.shiftName,
        startTime: data?.startTime,
        endTime: data?.endTime,
        checkInBufferTime: data?.checkInBufferTime,
        checkOutBufferTime: data?.checkOutBufferTime,
      });
    }
  }, [location?.state?.data?.id]);
  return (
    <Layout>
      <div className="content container-fluid">
        <BackButton
          label="Shift &amp; Time
                Configuration"
        />
        <form onSubmit={handleSubmit(onSubmit)}>
          <CardLayout>
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="pills-BasicDetails"
                role="tabpanel"
                aria-labelledby="pills-BasicDetails-tab"
                tabIndex={0}
              >
                <div className="row">
                  {/* <FieldLayout>
                    <Label id="shiftName">Work Type</Label>
                    <select
                      className="form-select form-control"
                      aria-label="Default select example"
                      {...register('type', {
                        ...errorTypes.required('Work Type'),
                      })}
                    >
                      <option value="" className="d-none">
                        Select Work Type
                      </option>
                      <option value="Office">Office</option>
                      <option value="Site">Site</option>
                    </select>
                    <ErrorMessage message={errors?.type?.message} />
                  </FieldLayout> */}
                  <FieldLayout fieldStyle="col-12 col-lg-6">
                    <PrimaryInput
                      errors={errors?.shiftName?.message}
                      label="Shift Name"
                      type="text"
                      placeholder="Shift Name"
                      {...register('shiftName', {
                        ...errorTypes.required('Shift Name'),
                        pattern: {
                          value: /^[A-Za-z][A-Za-z-]*$/,
                          message:
                            'Shift name must start with a letter  and may include letters, spaces, and hyphens',
                        },
                      })}
                    />
                  </FieldLayout>
                  <FieldLayout fieldStyle="col-12 col-lg-6">
                    <PrimaryInput
                      errors={errors?.startTime?.message}
                      label="Start Time"
                      type="time"
                      {...register('startTime', {
                        ...errorTypes.required('Start Time'),
                      })}
                      required={true}
                    />
                  </FieldLayout>
                  <FieldLayout fieldStyle="col-12 col-lg-6">
                    <PrimaryInput
                      label="End Time"
                      errors={errors?.endTime?.message}
                      type="time"
                      {...register('endTime', {
                        ...errorTypes.required('End Time'),
                      })}
                      required={true}
                    />
                  </FieldLayout>
                  <FieldLayout fieldStyle="col-12 col-lg-6">
                    <PrimaryInput
                      label="Check-In Buffer Time"
                      type="time"
                      errors={errors?.checkInBufferTime?.message}
                      placeholder="Enter check-In"
                      {...register('checkInBufferTime', {
                        ...errorTypes.required('Check-In Buffer Time'),
                        ...validations.checkInBufferTime,
                      })}
                      required={true}
                    />
                  </FieldLayout>
                  <FieldLayout fieldStyle="col-12 col-lg-6">
                    <PrimaryInput
                      label="Check-Out Buffer Time"
                      type="time"
                      placeholder="Enter check-Out"
                      errors={errors?.checkOutBufferTime?.message}
                      {...register('checkOutBufferTime', {
                        ...errorTypes.required('Check-Out Buffer Time'),
                        ...validations.checkOutBufferTime,
                      })}
                      required={true}
                    />
                  </FieldLayout>
                </div>
                <FormButtons
                  isLoading={isLoading}
                  buttonStyle="gap-3 mt-4 mb-3"
                >
                  {' '}
                  {location?.state?.data?.id ? 'Update' : 'Add'}
                </FormButtons>
              </div>
            </div>
          </CardLayout>
        </form>
      </div>
    </Layout>
  );
};
export default AddShiftAndTime;
